import React from 'react';
import Button from '@material-ui/core/Button';
import createHistory from 'history/createHashHistory';
const history = createHistory();

class CardHeader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    handleShowAllNotifAndClose = (param) => {
        if(param === "appNotification.title"){
            history.push('/app/alert-notification');
        } else if (param === "mailNotification.title") {
            history.push('/app/alert-notification-docs');
        } else {
            console.log("error param is not defined")
        }
    };

    render() {
        const {heading, subHeading, styleName, onAppNotificationSelect, onMailNotificationSelect} = this.props;
        if (heading.props.id == "appNotification.title") {
            return (
                <div className={`jr-card-header d-flex ${styleName}`}>
                    <div className="mr-auto">
                        <h3 className="card-heading">{heading}</h3>
                        {subHeading && <p className="sub-heading">{subHeading}</p>}
                    </div>
                    <Button color="primary" onClick={() => {
                        this.handleShowAllNotifAndClose(heading.props.id)
                        onAppNotificationSelect()
                    }}>Show All</Button>
                </div>
            )
        } else {
            return (
                <div className={`jr-card-header d-flex ${styleName}`}>
                    <div className="mr-auto">
                        <h3 className="card-heading">{heading}</h3>
                        {subHeading && <p className="sub-heading">{subHeading}</p>}
                    </div>
                    <Button color="primary" onClick={() => {
                        this.handleShowAllNotifAndClose(heading.props.id)
                        onMailNotificationSelect()
                    }}>Show All</Button>
                </div>
            )
        }
    }
}

export default CardHeader;
CardHeader.defaultProps = {
    styleName: '',
    subHeading: ''
};




// WEBPACK FOOTER //
// ./components/dashboard/Common/CardHeader/index.js